import { Col, message, Modal, Row, Spin } from "antd";
import React, {
  useState,
  useCallback,
  useRef,
  useMemo,
  useEffect,
} from "react";
import styled from "styled-components";
import AnswerForm from "../Template/AnswerForm";
import { ButtonFilled, ButtonOutlined } from "reusableComponent/UIButtons";
import {
  useHistory,
  useLocation,
} from "react-router-dom/cjs/react-router-dom.min";
import { RightOutlined } from "@ant-design/icons";
import { useSelector } from "react-redux";
import { getAllDepartmentList } from "redux/selectors";
import { CALL_API } from "common/API";
import { STATUS_CODE } from "common/Constants";
import dayjs from "dayjs";
import ViewKpi from "./ViewKpi";
import UserFloatingButton from "../UserFloatingButton";
import SuccessDeclinePopup from "reusableComponent/Popup/SuccessDeclinePopup";

const AttendWrap = styled.div`
  position: relative;
  height: calc(100vh - 150px);
  .scroll-container {
    overflow: auto;
    scrollbar-width: none;
    -ms-overflow-style: none;
  }

  .scroll-container::-webkit-scrollbar {
    display: none;
  }
`;

const StyledModal = styled(Modal)`
  .ant-modal-header {
    border-bottom: none;
    padding-top: 20px;
  }
  .ant-modal-title {
    font-weight: bold;
    font-weight: 1.2rem;
  }
  .ant-modal-body {
    padding-top: 0px;
  }
  .ant-modal-footer {
    display: none;
  }
  .ant-form-item-label {
    font-weight: 500;
  }
  .ant-picker {
    width: 100%;
  }
  .ant-picker-input > input[disabled],
  .ant-select-disabled.ant-select:not(.ant-select-customize-input)
    .ant-select-selector,
  .ant-input[disabled] {
    color: rgba(0, 0, 0, 1);
  }
`;

const prefixIds = (questions = [], prefix) =>
  questions.map((q) => ({ ...q, id: `${prefix}__${q.id}` }));

const isQuestionAnswered = (question) => {
  if (question.formType === "CHECKBOX") {
    return question.options?.some((opt) => opt.isChecked === true);
  }
  return (
    question.answer !== undefined &&
    question.answer !== null &&
    question.answer !== ""
  );
};

const Review = () => {
  const location = useLocation();
  const history = useHistory();
  const KpiData = location.state?.dataList;
  const isView = location.state?.isview || false;
  console.log("kpidata-->", isView);
  const [dataList, setDataList] = useState([]);
  const [isViewKpi, setIsViewKpi] = useState(false);
  const [loading, setLoading] = useState(false);
  const [popupOpen, setPopupOpen] = useState(false);
  console.log("dataList", dataList);
  const departmentList = useSelector(getAllDepartmentList);

  const introQuestions = useMemo(
    () => prefixIds(dataList?.appraiserintroductorysection || [], "intro"),
    []
  );
  const mainQuestions = useMemo(
    () => prefixIds(dataList?.appraisermainquestionnairesection || [], "main"),
    []
  );
  const remarkQuestions = useMemo(
    () => prefixIds(dataList?.appraiserremarkssection || [], "remark"),
    []
  );

  const [appraisarIntroductoryDetail, setAppraisarIntroductoryDetail] =
    useState(introQuestions);
  const [appraisarMainSectionDetail, setAppraisarMainSectionDetail] =
    useState(mainQuestions);
  const [appraisarRemarkSectionDetail, setAppraisarRemarkSectionDetail] =
    useState(remarkQuestions);

  const [submitLoading, setSubmitLoading] = useState(false);
  const [draftLoading, setDraftLoading] = useState(false);
  const [validationErrors, setValidationErrors] = useState({});

  const introSelectedItem = useRef({
    deleteStatus: false,
    questions: introQuestions,
  });
  const mainSelectedItem = useRef({
    deleteStatus: false,
    questions: mainQuestions,
  });
  const remarkSelectedItem = useRef({
    deleteStatus: false,
    questions: remarkQuestions,
  });

  const handleSetIntroductory = useCallback(
    (val) => setAppraisarIntroductoryDetail(val),
    []
  );
  const handleSetMain = useCallback(
    (val) => setAppraisarMainSectionDetail(val),
    []
  );
  const handleSetRemark = useCallback(
    (val) => setAppraisarRemarkSectionDetail(val),
    []
  );

  const handleClearError = useCallback((questionId) => {
    setValidationErrors((prev) => {
      if (!prev[questionId]) return prev;
      const updated = { ...prev };
      delete updated[questionId];
      return updated;
    });
  }, []);

  const stripPrefix = (questions = []) =>
    questions.map((q) => ({
      ...q,
      id: q.id.includes("__") ? q.id.split("__")[1] : q.id,
    }));

  const validate = () => {
    const errors = {};
    [
      ...appraisarIntroductoryDetail,
      ...appraisarMainSectionDetail,
      ...appraisarRemarkSectionDetail,
    ]
      .filter((q) => q.question) // ✅ skip if no question text
      .forEach((q) => {
        if (!isQuestionAnswered(q)) {
          errors[q.id] = true;
        }
      });
    return errors;
  };

  const onCompleteClick = async () => {
    const errors = {};
    [...appraisarMainSectionDetail]
      .filter((q) => q.question)
      .forEach((q) => {
        if (!isQuestionAnswered(q)) {
          errors[q.id] = true;
        }
      });

    if (Object.keys(errors).length > 0) {
      setValidationErrors(errors);
      const firstErrorId = Object.keys(errors)[0];
      const el = document.getElementById(`question-${firstErrorId}`);
      if (el) el.scrollIntoView({ behavior: "smooth", block: "center" });
      return;
    }

    setValidationErrors({});
    setSubmitLoading(true);

    const payload = {
      reviewedon: dayjs().format("DD-MM-YYYY") || "",
      appraisermainquestionnairesection:
        stripPrefix(appraisarMainSectionDetail) || [],
      appraiserintroductorysection:
        stripPrefix(appraisarIntroductoryDetail) || [],
      appraiserremarkssection: stripPrefix(appraisarRemarkSectionDetail) || [],
      reviewstatus: "1",
    };

    console.log("payload-->", payload);
    const { code } = await CALL_API(
      `performance/reviewappraisal/${KpiData?.id}`,
      "patch",
      payload
    );
    if (code === STATUS_CODE.SUCCESS) {
      setPopupOpen(true);
      setTimeout(() => {
        setPopupOpen(false);
        setSubmitLoading(false);
        history.push("/performance", { id: "2" });
      }, 2000);
    } else {
      message.error("something went wrong");
      setSubmitLoading(false);
    }
  };

  const onSaveAsDraftClick = async () => {
    setDraftLoading(true);

    const payload = {
      reviewedon: "",
      appraisermainquestionnairesection:
        stripPrefix(appraisarMainSectionDetail) || [],
      appraiserintroductorysection:
        stripPrefix(appraisarIntroductoryDetail) || [],
      appraiserremarkssection: stripPrefix(appraisarRemarkSectionDetail) || [],
      reviewstatus: "0",
    };

    console.log("draft payload-->", payload);
    const { code } = await CALL_API(
      `performance/reviewappraisal/${KpiData?.id}`,
      "patch",
      payload
    );
    if (code === STATUS_CODE.SUCCESS) {
      setPopupOpen(true);
      setTimeout(() => {
        setPopupOpen(false);
        setDraftLoading(false);
        history.push("/performance", { id: "2" });
      }, 2000);
    } else {
      setDraftLoading(false);
    }
  };

  const fetchData = async () => {
    setLoading(true);
    try {
      const { data, code } = await CALL_API(
        `performance/reviewappraisal
/${KpiData?.appraiseruserid}?kpiid=${
          KpiData?.id
          // userInfo?.userid
        }`,
        "get"
      );
      console.log("code-->", code);
      if (code === STATUS_CODE.SUCCESS) {
        console.log("data12-->", data);
        setDataList(data[0]);
        setLoading(false);
      } else {
        throw new Error(`Failed to fetch data: ${code}`);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  useEffect(() => {
    if (dataList?.appraiserintroductorysection) {
      setAppraisarIntroductoryDetail(
        prefixIds(dataList.appraiserintroductorysection, "intro")
      );
      introSelectedItem.current.questions = prefixIds(
        dataList.appraiserintroductorysection,
        "intro"
      );
    }
    if (dataList?.appraisermainquestionnairesection) {
      setAppraisarMainSectionDetail(
        prefixIds(dataList.appraisermainquestionnairesection, "main")
      );
      mainSelectedItem.current.questions = prefixIds(
        dataList.appraisermainquestionnairesection,
        "main"
      );
    }
    if (dataList?.appraiserremarkssection) {
      setAppraisarRemarkSectionDetail(
        prefixIds(dataList.appraiserremarkssection, "remark")
      );
      remarkSelectedItem.current.questions = prefixIds(
        dataList.appraiserremarkssection,
        "remark"
      );
    }
  }, [dataList]);

  const footerStyle = {
    position: "sticky",
    bottom: -20,
    left: 0,
    right: 0,
    backgroundColor: "#fff",
    padding: "10px",
    display: "flex",
    justifyContent: "end",
    boxShadow: "0 2px 10px rgba(0, 0, 0, 0.1)",
    margin: "0px -20px",
  };

  const ratingSummary = useMemo(() => {
    const ratingQuestions = appraisarMainSectionDetail.filter(
      (q) => q.formType === "RATING"
    );

    const totalStars = ratingQuestions.reduce(
      (sum, q) => sum + (q.starCount || 0),
      0
    );

    const totalValue = ratingQuestions.reduce(
      (sum, q) => sum + (Number(q.answer) || 0),
      0
    );

    const percentage = totalStars > 0 ? (totalValue / totalStars) * 100 : 0;

    return {
      name: "Appraiser's Score",
      totalStars,
      totalValue,
      percentage,
    };
  }, [appraisarMainSectionDetail]);
  useEffect(() => {
    fetchData();
  }, []);

  return (
    <AttendWrap>
      <StyledModal
        title={"Appraisee's KPI"}
        visible={isViewKpi}
        onCancel={() => {
          setIsViewKpi(false);
        }}
        width={800}
        footer={[]}
      >
        <ViewKpi dataList={dataList} />
      </StyledModal>

      <Spin spinning={loading}>
        <div
          className="scroll-container"
          style={{
            height: isView ? "calc(100vh - 150px)" : "calc(100vh - 200px)",
            overflowY: "scroll",
          }}
        >
          <div className="breadcrumb">
            <p
              className="lite-text p-0 m-0"
              style={{ cursor: "pointer" }}
              onClick={() => history.push("/performance", { id: "2" })}
            >
              Performance
            </p>
            &nbsp;
            <RightOutlined className="mt-1" />
            &nbsp;
            <p className="m-0 p-0">
              {isView ? "Review" : "Reviewing Appraisee"}
            </p>
          </div>

          <div className="mb-3">
            <Row gutter={[16, 16]} style={{ marginRight: "0px" }}>
              <Col xs={24} md={12}>
                <Row gutter={16}>
                  <Col xs={24} md={12} className="lite-text">
                    Name of the Employee
                  </Col>
                  <Col xs={24} md={12}>
                    {KpiData?.fullname || "-"}
                  </Col>
                </Row>
              </Col>
              <Col xs={24} md={12}>
                <Row gutter={16}>
                  <Col xs={24} md={12} className="lite-text">
                    Departments
                  </Col>
                  <Col xs={24} md={12}>
                    {KpiData?.departmentname || "-"}
                  </Col>
                </Row>
              </Col>
              <Col xs={24} md={12}>
                <Row gutter={16}>
                  <Col xs={24} md={12} className="lite-text">
                    Title
                  </Col>
                  <Col xs={24} md={12}>
                    {KpiData?.title || "-"}
                  </Col>
                </Row>
              </Col>
              <Col xs={24} md={12}>
                <Row gutter={16}>
                  <Col xs={24} md={12} className="lite-text">
                    KPI Template
                  </Col>
                  <Col xs={24} md={12}>
                    {KpiData?.templatename || "-"}
                  </Col>
                </Row>
              </Col>
              <Col xs={24} md={12}>
                <Row gutter={16}>
                  <Col xs={24} md={12} className="lite-text">
                    Hired Date
                  </Col>
                  <Col xs={24} md={12}>
                    {KpiData?.hireddate || "-"}
                  </Col>
                </Row>
              </Col>
              <Col xs={24} md={12}>
                <Row gutter={16}>
                  <Col xs={24} md={12} className="lite-text">
                    Type
                  </Col>
                  <Col xs={24} md={12}>
                    {KpiData?.type || "-"}
                  </Col>
                </Row>
              </Col>
              <Col xs={24} md={12}>
                <Row gutter={16}>
                  <Col xs={24} md={12} className="lite-text">
                    Start date to attend appraisal
                  </Col>
                  <Col xs={24} md={12}>
                    {KpiData?.attendstartdate || "-"}
                  </Col>
                </Row>
              </Col>
            </Row>
          </div>

          {appraisarIntroductoryDetail?.[0]?.question && (
            <>
              <h6>Indroductory Section</h6>
              <p className="lite-text">
                This section is used to collect basic details of appraisee and
                set context for the appraisal. This may include information like
                employee name, role, brief note etc...
              </p>
              <AnswerForm
                fullFormDetail={appraisarIntroductoryDetail}
                selectedItem={introSelectedItem.current}
                setAnswerResponse={handleSetIntroductory}
                validationErrors={validationErrors}
                onClearError={handleClearError}
                isView={isView}
                ratingSummary={ratingSummary}
              />
            </>
          )}

          {appraisarMainSectionDetail?.[0]?.question && (
            <>
              <h6 className="mt-5">
                Main Questionnaire Section
                <span className="text-danger">*</span>
              </h6>
              <p className="lite-text">
                This is the core performance evaluation section. Employees rate
                themselves and answer questions related to skills, goals, and
                performance. These questions will be automatically duplicated in
                the Appraiser form so that both self-ratings and reviewer
                ratings can be compared.
              </p>
              <AnswerForm
                fullFormDetail={appraisarMainSectionDetail}
                selectedItem={mainSelectedItem.current}
                setAnswerResponse={handleSetMain}
                validationErrors={validationErrors}
                onClearError={handleClearError}
                isView={isView}
              />
            </>
          )}

          {appraisarRemarkSectionDetail?.[0]?.question && (
            <>
              <h6 className="mt-5">Remarks & Feedback Section</h6>
              <p className="lite-text">
                This section allows the employee to share additional comments,
                challenges, achievements, or expectations. It supports open
                feedback beyond ratings.
              </p>
              <AnswerForm
                fullFormDetail={appraisarRemarkSectionDetail}
                selectedItem={remarkSelectedItem.current}
                setAnswerResponse={handleSetRemark}
                validationErrors={validationErrors}
                onClearError={handleClearError}
                isView={isView}
              />
            </>
          )}
        </div>
        <UserFloatingButton
          isViewKpi={isViewKpi}
          setIsViewKpi={setIsViewKpi}
          bottompossition={isView ? "20px" : "80px"}
        />
        {!isView && (
          <div style={footerStyle}>
            <ButtonOutlined
              className="border-0"
              onClick={() => history.push("/performance")}
            >
              Cancel
            </ButtonOutlined>
            <ButtonOutlined
              // className="border-0"
              loading={draftLoading}
              onClick={onSaveAsDraftClick}
            >
              Save as Draft
            </ButtonOutlined>
            <ButtonFilled
              type="primary"
              loading={submitLoading}
              onClick={onCompleteClick}
            >
              Complete
            </ButtonFilled>
          </div>
        )}
      </Spin>
      <SuccessDeclinePopup
        open={popupOpen}
        setOpen={setPopupOpen}
        type="success"
        message={submitLoading ? "Completed" : "Draft Saved"}
      />
    </AttendWrap>
  );
};

export default Review;
